import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { StarRatingComponent } from './star-rating.component';
import { MatRadioModule } from '@angular/material/radio';
import { RatingService } from 'app/services/rating.service';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, tap } from 'rxjs';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-stepper-rating',
  standalone: true,
  templateUrl: './stepper-rating.component.html',
  styleUrl: './stepper-rating.component.scss',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    NgIf,
    MatButtonModule,
    MatRadioModule,
    StarRatingComponent,
  ],
})
export class StepperRatingComponent implements OnInit {
  form: FormGroup;
  private _istanzeService = inject(IstanzeService);
  private _ratingService = inject(RatingService);
  private _router = inject(Router);
  private _fb = inject(FormBuilder);


  options1 = [
    { value: 1, label: 'A volte le indicazioni non erano chiare' },
    { value: 2, label: 'A volte le indicazioni non erano complete' },
    { value: 3, label: 'A volte non capivo se stavo procedendo correttamente' },
    { value: 4, label: 'Ho avuto problemi tecnici' },
    { value: 5, label: 'Altro' },
  ];
  options2 = [
    { value: 6, label: 'Le indicazioni erano chiare' },
    { value: 7, label: 'Le indicazioni erano complete' },
    { value: 8, label: 'Capivo sempre che stavo procedendo correttamente' },
    { value: 9, label: 'Non ho avuto problemi tecnici' },
    { value: 5, label: 'Altro' },
  ];

  step: number = 0;
  istanza: Istanza;
  visible: boolean = true;

  ngOnInit(): void {

    this._istanzeService.istanza$.subscribe(
      istanza => {
        this.istanza = istanza;
        if (istanza){
          this.visible = (this.istanza.stato_id=='presentata' && this.istanza.numero_protocollo && !this.istanza.stars);
        }
      }

    )
    this.form = this._fb.group({
      rating: [null],
      option: [null],
      comment: [''],
      email: [''],
    });

    //se cambio il valore riparto con la valutazione
    this.form.get('rating')?.valueChanges.subscribe(() => this.step = 1 );

  }

  onNext() {

    this.step++;
    if (this.step==3){
       this.submit()
    }

  }

  submit() {
    if (this.istanza) {
      this._ratingService.createRating({ document: this.istanza.codice, ...this.form.value }).pipe(
        switchMap(() => this._istanzeService.updateIstanza({ id: this.istanza.id, stars: this.form.get('rating').value }, false)
        )).subscribe(()=>{ })
    }
    else {
      this._ratingService.createRating({ document: this._router.url, ...this.form.value }).subscribe(()=>{ })
    }
  }
}
